import React, { memo, useCallback, useEffect, useState } from 'react'
import Autocomplete from '@material-ui/lab/Autocomplete'
import TextField from '@material-ui/core/TextField'
import debounce from 'lodash/debounce'

// TODO: Mover a ./form
function DebounceAutocomplete({
   getOptionsAsync,
   textFieldLabel,
   textFieldError,
   renderOption,
   getOptionLabel,
   onChange,
   disabled,
   def
}) {
   const [options, setOptions] = useState([])
   const [inputValue, setInputValue] = useState('')

   const getOptionsDelayed = useCallback(
      debounce((text, callback) => {
         if (text) {
            setOptions([])
            getOptionsAsync(text).then(callback)
         }
      }, 1000),
      []
   )

   return (
      <Autocomplete
         value={def ?? null}
         size="small"
         options={options || []}
         filterOptions={x => x} // disable filtering on client
         onInputChange={(_, newInputValue, reason) => {
            setInputValue(newInputValue)
            if (reason === 'input') {
               getOptionsDelayed(newInputValue, filteredOptions => {
                  setOptions(filteredOptions)
               })
            } else if (reason === 'reset') {
               setOptions([])
            }
         }}
         renderOption={renderOption}
         getOptionLabel={getOptionLabel}
         onChange={onChange}
         renderInput={params => (
            <TextField {...params} label={textFieldLabel} variant="outlined" error={textFieldError} />
         )}
         disabled={disabled}
      />
   )
}

export default memo(DebounceAutocomplete)
